export default __webpack_public_path__ + "static/media/cern-extrabold-italic.184b8c7e.woff2";